const DynamicReleaseLabel = ({
  label,
  onClick,
}: {
  label: {
    id: number;
    name: string;
  };
  onClick: (id: number) => void;
}) => (
  <div
    className="group relative rounded-sm border border-dashed border-blue-500 px-2 py-0.5 text-xs font-medium text-blue-400 hover:bg-blue-50"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(label.id);
    }}
    key={label.name}
  >
    {label.name}
  </div>
);

export default DynamicReleaseLabel;
